import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CallState } from '@lcs/shared/api';
import { Observable } from 'rxjs';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { FormComponent } from 'src/app/common-components/forms-base/form-component.interface';
import { GetAccountDetail_account } from '../../queries/generated/GetAccountDetail';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-account-log-level',
    styleUrls: [],
    templateUrl: './account-log-level.component.html',
    standalone: false
})
export class AccountLogLevelComponent implements FormComponent {
   form: UntypedFormGroup;

   callState$: Observable<CallState>;

   account: GetAccountDetail_account | null;

   title: string = 'Change Log Level';

   constructor(
      private fb: UntypedFormBuilder,
      public dialogRef: MatDialogRef<AccountLogLevelComponent>,
      public dialogService: LcsDialogService,
      @Inject(MAT_DIALOG_DATA)
      public data: {
         account: GetAccountDetail_account | null;
      }
   ) {
      this.account = data.account;
      this.form = this.fb.group({
         logLevelId: fb.control({ logLevelId: this.account?.logLevelId }),
         reasonLogLevelChanged: fb.control(
   this.account?.logLevelId === 'Info'
      ? null
      : this.account?.reasonLogLevelChanged,
   this.account?.logLevelId === 'Info'
      ? []
      : [Validators.required]
),
      });

      this.form.get('logLevelId')?.valueChanges.subscribe((logLevelId: any) => {
         const reasonControl = this.form.get('reasonLogLevelChanged');

         if (!reasonControl) return;

         if (logLevelId?.logLevelId === 'Info') {
            reasonControl.clearValidators();
            reasonControl.setValue(null);
         } else {
            reasonControl.setValidators([Validators.required]);
         }

         reasonControl.updateValueAndValidity();
      });
   }

   onCloseClick(): void {
      this.dialogService.close();
   }

   onConfirm(): void {
      if (this.form.valid) {
         this.dialogRef.close(this.form.value);
      }
   }
}
